import React from "react";

export default function Bola({ id }) {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#23468C" />
      <circle cx="17.7706" cy="18.2764" r="11.0769" fill="white" />
      <mask
        id="mask0_362_1179"
        style="mask-type:alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="36"
        height="36"
      >
        <circle cx="18" cy="18" r="18" fill="url(#paint0_linear_362_1179)" />
      </mask>
      <g mask="url(#mask0_362_1179)">
        <circle cx="-8.39885" cy="17.9995" r="10.8" fill="white" />
        <circle cx="18" cy="-8.40117" r="10.8" fill="white" />
        <circle cx="18" cy="45.1999" r="10.8" fill="white" />
        <circle cx="44.4024" cy="17.9995" r="10.8" fill="white" />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_362_1179"
          x1="18.4"
          y1="2.14003e-06"
          x2="40.3008"
          y2="24.087"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#485DBD" />
          <stop offset="1" stop-color="#1D8C75" />
        </linearGradient>
      </defs>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/rifa/components/layout/icons/bolaIcon.jsx